import React from 'react';
import { Box } from '@mui/material';
import { Icon } from '@livable/saas-react-components';
import useStyles from './styles';

/**
 * A tab's loading state: it covers the tab's content, and only that.
 *
 * Deliberately not BackdropLoader: that is a fixed, full-viewport MUI Backdrop, so while a tab
 * loaded it swallowed clicks on the tab bar above it and the page could not be left. The slowest
 * load here walks every page of subscriptions, which is tens of seconds of a locked screen.
 *
 * It covers rather than displaces: it is positioned against the page's content area, so the
 * toolbar and table underneath keep the layout they will have once the load lands.
 */
export const TabLoader = _ref => {
  let isLoading = _ref.isLoading;
  const classes = useStyles();
  if (!isLoading) return null;
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.tabLoader
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "large",
    isSpinning: true,
    pattern: "gradient",
    type: "loader"
  }));
};